<template>
  <div class="text-center mt-4">
    <v-btn class="ma-4" @click="onRemove" color="red" outlined>Xóa lớp bán trú</v-btn>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  methods: {
    ...mapActions('boardingClass', ['remove']),
    onRemove() {
      this.$dialog.confirm({
        title: 'Xác nhận xóa lớp bán trú',
        text: 'Lớp bán trú này sẽ bị xóa khỏi danh sách bán trú. Thao tác này sẽ không thể hoàn tác. Bạn có chắc chắn muốn xóa lớp bán trú?',
        okText: 'OK',
        cancelText: 'Hủy',
        type: 'delete',
        done: async () => {
          try {
            await this.remove(this.$route.params.id)
            this.$alert.success('Xóa lớp bán trú thành công!')
            this.$router.push('/boarding-class/')
          } catch (error) {
            this.$alert.deleteError()
          } finally {
            this.$loading.active = false
          }
        },
      })
    },
  },
}
</script>